var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toolbar = void 0;
var React = __importStar(require("react"));
var Toolbar_1 = __importDefault(require("@material-ui/core/Toolbar"));
var clsx_1 = __importDefault(require("clsx"));
var Toolbar_styles_1 = require("./Toolbar.styles");
var getVariantForMaterial_1 = require("./getVariantForMaterial");
exports.Toolbar = React.forwardRef(function (props, ref) {
    var className = props.className, variant = props.variant, other = __rest(props, ["className", "variant"]);
    var variantForMaterial = (0, getVariantForMaterial_1.getVariantForMaterial)({ variant: variant });
    var classes = (0, Toolbar_styles_1.useStyles)();
    var classNames = (0, clsx_1.default)(className, variant === 'prominent' && classes.prominent);
    return (React.createElement(Toolbar_1.default, __assign({ className: classNames, ref: ref, variant: variantForMaterial }, other)));
});
exports.Toolbar.displayName = 'Toolbar';
exports.default = exports.Toolbar;
//# sourceMappingURL=Toolbar.js.map